import { createStore } from '@stencil/store';
import {
  MainNavigation,
  SearchConfig
} from '../components/ds-contextual-navigation/ds-contextual-navigation';

export interface Store {
  isMobileView: boolean;
  searchConfig: SearchConfig;
  mainLinks: Array<MainNavigation>;
}

const { state, onChange, dispose } = createStore<Store>({
  isMobileView: undefined,
  searchConfig: null,
  mainLinks: null
});

export default state;
export { onChange, dispose };
